import styled, { keyframes } from "styled-components";

const fadeIn = keyframes` from { opacity: 0; } to { opacity: 1; } `;
const slideIn = keyframes` from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } `;
const pulse = keyframes` 0% { box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.4); } 70% { box-shadow: 0 0 0 15px rgba(212, 175, 55, 0); } 100% { box-shadow: 0 0 0 0 rgba(212, 175, 55, 0); } `;

export const BannerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 8, 20, 0.95);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12000;
  padding: 15px;
  box-sizing: border-box;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const BannerContainer = styled.div`
  background: radial-gradient(circle at top right, #ffffff, #fdfbf0);
  border-radius: 24px;
  border: 1px solid #d4af37;
  padding: 24px;
  box-sizing: border-box;
  max-width: 900px;
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  animation: ${slideIn} 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 95vw;
    padding: 20px;
  }

  @media (max-width: 480px) {
    padding: 16px;
    box-sizing: border-box;
    border-radius: 20px;
  }
`;

export const BannerImage = styled.img`
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 16px;
  display: block;
  margin-bottom: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);

  @media (max-width: 480px) {
    margin-bottom: 14px;
    border-radius: 12px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  flex-shrink: 0;
`;

export const AcceptButton = styled.button`
  background: linear-gradient(135deg, #d4af37 0%, #b8860b 100%);
  color: white;
  padding: 20px 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: ${pulse} 2s infinite;

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.1);
    box-shadow: 0 10px 20px rgba(212, 175, 55, 0.3);
  }

  @media (max-width: 480px) {
    padding: 16px 20px;
    box-sizing: border-box;
    font-size: 15px;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  color: #718096;
  border: none;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #2d3748;
    text-decoration: underline;
  }
`;
